import React from "react";

const SelectBoxes = ({ element }) => {
  const values = Array.isArray(element?.data?.values) ? element.data.values : [];

  return (
    <div>
      {values.map((option, index) => (
        <div key={`selectBoxes${index}`}>
          <input type="checkbox" name="day" value={option?.value || ""} />
          <label>{option?.label || "Unnamed Option"}</label>
          <br />
        </div>
      ))}
    </div>
  );
};

export default SelectBoxes;
